/**
 * Slim CSS device frame for real app screenshots (AI-11994).
 * ~40px outer radius, thin dark bezel, optional notch pill, blue-tinted
 * layered shadow, and an ambient sky-glow wash behind the phone so the
 * mockups float with premium depth instead of sitting flat on the page.
 */
type DeviceFrameProps = {
  src: string;
  alt: string;
  className?: string;
  /** Ambient radial sky glow behind the phone. */
  glow?: boolean;
  /** Dynamic-island style pill over the (empty) status-bar center. */
  notch?: boolean;
  loading?: "eager" | "lazy";
  /** `phone` = hero depth, `float` = lighter row depth. */
  depth?: "phone" | "float";
};

export function DeviceFrame({
  src,
  alt,
  className = "",
  glow = true,
  notch = true,
  loading = "lazy",
  depth = "phone",
}: DeviceFrameProps) {
  return (
    <div className={`relative ${className}`}>
      {glow ? (
        <div aria-hidden className="pointer-events-none absolute -inset-10 bg-sky-glow blur-2xl sm:-inset-14" />
      ) : null}
      <div
        className={[
          "relative rounded-[40px] bg-[#10131b] p-[9px] ring-1 ring-black/40",
          depth === "phone" ? "shadow-phone" : "shadow-phone-float",
        ].join(" ")}
      >
        <div className="relative overflow-hidden rounded-[31px] bg-[#10131b]">
          <img
            src={src}
            alt={alt}
            loading={loading}
            decoding="async"
            width={585}
            height={1266}
            className="block h-auto w-full"
          />
          {notch ? (
            <div
              aria-hidden
              className="absolute left-1/2 top-[9px] h-[20px] w-[74px] -translate-x-1/2 rounded-full bg-[#10131b]"
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
